class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary.nextElementSibling;
    this.leaveTimeout = null;

    // Prevent default <summary> click toggle behavior (hover-only mode)
    this.summary.addEventListener('click', (e) => {
      e.preventDefault();
    });

    // Improved hover-based toggle using pointer events
    this.addEventListener('pointerenter', this.onPointerEnter.bind(this));
    this.addEventListener('pointerleave', this.onPointerLeave.bind(this));

    // Fallback for focus loss (keyboard nav)
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) {
      this.animations = this.content.getAnimations?.() || [];
    }

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play?.());
    } else {
      this.animations.forEach((animation) => animation.cancel?.());
    }
  }

  onPointerEnter() {
    clearTimeout(this.leaveTimeout); // Prevent close if hovered back quickly
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.classList.add('is-open');
    this.summary.setAttribute('aria-expanded', true);
  }

  onPointerLeave() {
    // Add delay before closing to prevent flickering
    this.leaveTimeout = setTimeout(() => {
      this.mainDetailsToggle.classList.remove('is-open');
      this.close();
    }, 200); // Adjust the delay (in ms) as needed
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', false);
    this.onToggle();
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    super.onToggle();

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== ''
    )
      return;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
